<script setup lang="ts">
import type { AnyItem, GlobalCollectionId } from '#layers/data-model/public';
import { RenderCollectionDisplayTemplate } from '#layers/blocks/public';
import { CollectionReads } from '#layers/data-model/public';

const { item, collectionId, fallback, isLoading = false, layout } = defineProps<{
	item: AnyItem | undefined;
	collectionId: GlobalCollectionId;
	fallback: string;
	isLoading?: boolean;
	layout?: 'fill' | 'fit-content';
}>();
</script>

<template>
	<DSkeleton v-if="isLoading && !item" class="h-4 w-24 rounded-sm" />
	<RenderCollectionDisplayTemplate
		v-else-if="item"
		:item
		:collection-id
		:read="CollectionReads.Many"
		:layout
		class="h-4"
	/>
	<span v-else>{{ fallback }}</span>
</template>
